<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" @click.self="$emit('close')">
    <div class="relative w-full max-w-md bg-white dark:bg-[#1C2128] border border-gray-100 dark:border-gray-700 rounded-xl shadow-lg">
      <button @click="$emit('close')"
        class="absolute top-3 right-3 text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white rounded-lg p-1.5">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>

      <div class="px-6 py-6">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">{{ I18N.application.bookings.upcoming.cancel_booking }}</h3>

        <div class="text-sm text-gray-600 dark:text-gray-400 space-y-1">
          <p class="font-semibold text-gray-900 dark:text-white">{{ booking.event_name }}</p>
          <p>{{ booking.attendee_name }} ({{ booking.attendee_email }})</p>
          <p>{{ booking.host_formatted_target_date }} ({{ booking.host_ui_booking_time }})</p>
        </div>

        <p class="text-sm text-gray-600 dark:text-gray-400 my-4">{{ I18N.application.bookings.upcoming.cancel_description }}</p>

        <form @submit.prevent="submit">
          <label class="block mb-2 text-sm font-semibold text-gray-900 dark:text-gray-300">
            {{ I18N.application.bookings.upcoming.reason }} *
          </label>
          <textarea v-model="reason" rows="4" maxlength="300" required :disabled="canceling"
            :placeholder="I18N.application.bookings.upcoming.reason_placeholder"
            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 rounded-lg text-sm text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60"></textarea>

          <div class="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
            <button type="button" @click="$emit('close')" :disabled="canceling"
              class="px-5 py-2.5 text-sm font-medium text-gray-600 dark:text-gray-400 bg-white dark:bg-[#1C2128] border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
              {{ I18N.application.bookings.upcoming.cancel }}
            </button>
            <button type="submit" :disabled="canceling"
              class="flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 rounded-lg transition-colors">
              <svg v-if="canceling" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4z"/>
              </svg>
              {{ canceling ? I18N.application.bookings.upcoming.canceling : I18N.application.bookings.upcoming.cancel_booking }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useConstants } from 'composables/useConstants.js'
import { useEventBookingsStore } from 'stores/eventBookings.js'

const props = defineProps({
  eventId: { type: [String, Number], required: true },
  booking: { type: Object, required: true },
  flash: { type: Object, default: null },
})
const emit = defineEmits(['close', 'canceled'])

const { I18N } = useConstants()
const store = useEventBookingsStore()

const reason = ref('')
const canceling = ref(false)

async function submit() {
  canceling.value = true
  const result = await store.cancelBooking(props.eventId, props.booking, reason.value)
  canceling.value = false

  if (result.success) {
    props.flash?.value?.show(result.message, 'notice')
    emit('canceled')
    emit('close')
  } else {
    props.flash?.value?.show(result.message, 'alert')
  }
}
</script>
